import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { moduleName } from './constants'
import { FETCH_STATUS, ICommonState, TLoaderProps } from './types'

const initialState: ICommonState = {
  isLoading: false,
  loadingStack: {
    pendingItemsLoading: 0
  },
  loaderProps: {
    isFileUpload: false,
    message: ''
  }
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setLoading(state: ICommonState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setAppVersion(state: ICommonState, action: PayloadAction<string>) {
      if (action.payload !== state.appVersion) {
        state.appVersion = action.payload
      }
    },
    setAppBuildDate(state: ICommonState, action: PayloadAction<string>) {
      if (action.payload !== state.appBuildDate) {
        state.appBuildDate = action.payload
      }
    },
    updateLoadingStack(
      state: ICommonState,
      action: PayloadAction<FETCH_STATUS>
    ) {
      const updatedStack = {
        pendingItemsLoading: state.loadingStack.pendingItemsLoading
      }
      switch (action.payload) {
        case FETCH_STATUS.REQUEST_STARTED:
          updatedStack.pendingItemsLoading =
            updatedStack.pendingItemsLoading + 1
          break
        case FETCH_STATUS.REQUEST_FINISHED:
          updatedStack.pendingItemsLoading =
            updatedStack.pendingItemsLoading - 1
          break
      }
      state.loadingStack = updatedStack
    },
    clearLoadingStack(state: ICommonState) {
      state.loadingStack = { pendingItemsLoading: 0 }
    },
    setLoaderProps(state: ICommonState, action: PayloadAction<TLoaderProps>) {
      state.loaderProps = action.payload
    }
  }
})

export default slice.reducer
export const {
  setLoading,
  setAppVersion,
  setAppBuildDate,
  setLoaderProps,
  updateLoadingStack,
  clearLoadingStack
} = slice.actions
